module.exports = __webpack_public_path__ + "img/3.f8758f73.png";